import React, { useEffect, useState } from "react";
import { getAllProperties, getPropertiesBySearchParams } from "../services/propertyService";
import { Box, FormControl, FormControlLabel, FormLabel, Grid2, Pagination, Radio, RadioGroup } from "@mui/material";
import Product from "./section-components/product";
import EnhancedPropertyCard from "./EnhancedPropertyCard";
import SearchBar from "./section-components/SearchBar";
import { Pageheader } from "./global-components/page-header";
// import bgImage from '../assets/img/newimgaes/Sales Main Photo.jpeg';
import bgIndiaImage from '../assets/img/newimgaes/Sales India1.jpeg';
import Toast from "../components/Toast"
// import { useParams } from "react-router-dom";

export const Sales = () => {
    const [properties, setProperties] = useState([]);
    // const { country } = useParams();
    // const [searchParams, setSearchParam] = useState(() => {
    //     const initialParams = { country };
    //     return initialParams;
    // });
    const [searchParams, setSearchParam] = useState({ country: 'India' });
    const [excludeSold, setExcludeSold] = useState("no");
    const [page, setPage] = useState(1);
    const itemsPerPage = 9;
    const [toastOpen, setToastOpen] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    // Memoize the search param setter to avoid unnecessary re-renders
    const handleSearchParamChange = React.useCallback((values) => {
        setSearchParam(values);
    }, []);

    // Effect to update searchParams when country changes
    // useEffect(() => {
    //     setSearchParam(prev => ({ ...prev, country }));
    // }, [country]);

    // Effect to load properties when searchParams changes
    useEffect(() => {
        const loadProperties = async () => {
            try {
                const res = await getAllProperties(searchParams);
                const filteredProperties = res.filter((property) =>
                    ["For Sale", "Sold", "SSTC"].includes(property.propertyStatus)
                );
                setProperties(filteredProperties);
            } catch (error) {
                setToastMessage("Failed to load properties.");
                setToastOpen(true);
            }
        };
        loadProperties();
    }, [searchParams]);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleExcludeSoldChange = (e) => {
        setExcludeSold(e.target.value);
    };

    const filteredProperties = properties.filter((property) =>
        excludeSold === "yes" ? property.propertyStatus !== "Sold" : true
    );

    const paginatedProperties = filteredProperties.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    const content = `At Royale Spaces, every property listed for sale goes through a rigorous verification process to ensure complete transparency and peace of mind for our buyers. From legal title checks to owner authentication and compliance with local regulations, we ensure each listing is 100% genuine and ready for sale.

✅ Title and Ownership Verified
✅ No Legal Disputes or Encumbrances
✅ Accurate Market Valuation
✅ Clear Documentation

We believe in building trust through verified information. Whether you're a first-time homebuyer or a seasoned investor, explore our Verified Property Listings and make your next move with confidence.`

    return (
        <>
            <Pageheader headertitle="Sales" bgImage={bgIndiaImage} subTitle={"India"} />

            <SearchBar setSearchBack={handleSearchParamChange} isSell statusType={'For Sale'} country={"India"} />
            {/* {country === 'India' && ( */}
                <div className="container p-2 mt-2 mb-2" style={{
                    whiteSpace: 'pre-line',
                }}>
                    {content}
                </div>
            {/* )} */}
            {/* <img src={bgImage}/> */}
            <div className="container p-2">
                <Box className='mt-4'>
                    <FormControl>
                        <FormLabel>Exclude Sold</FormLabel>
                        <RadioGroup
                            row
                            value={excludeSold}
                            onChange={handleExcludeSoldChange}
                        >
                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                            <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <div className="propartes-area" style={{ paddingTop: "10px" }}>
                    {/* <Grid2 container spacing={2}>
                        {paginatedProperties.map((property, index) => (
                            <Product key={index} property={property} gridMd={4} country={country}/>
                        ))}
                    </Grid2> */}
                    <Grid2 container spacing={2} justifyContent="center">
                        {paginatedProperties.length > 0 ? (
                            paginatedProperties.map((property, index) => (
                                <Grid2 key={index} xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <EnhancedPropertyCard property={property} />
                                </Grid2>
                            ))
                        ) : (
                            <Box
                                sx={{
                                    width: "100%",
                                    textAlign: "center",
                                    padding: "2rem 0",
                                    fontSize: "1.2rem",
                                    fontWeight: "500",
                                    color: "#555",
                                }}
                            >
                                No properties found matching your criteria.
                            </Box>
                        )}
                    </Grid2>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: 3,
                            marginBottom: 3,
                        }}
                    >
                        <Pagination
                            count={Math.ceil(filteredProperties.length / itemsPerPage)}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                        />
                    </Box>
                </div>
            </div>
            <Toast open={toastOpen} severity="error" message={toastMessage} onClose={() => setToastOpen(false)} />
        </>
    );
};
